/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Combine_1Inputs */

const en_pc_tut_combine_1 = /** @type {(inputs: Pc_Tut_Combine_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine: open Combine files, add any number of PDFs and combine them. Each file gets its own bookmark.`)
};

const zh_pc_tut_combine_1 = /** @type {(inputs: Pc_Tut_Combine_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并：打开「Combine files」，添加任意数量的 PDF 并合并，每个文件都会生成独立书签。`)
};

/**
* | output |
* | --- |
* | "Combine: open Combine files, add any number of PDFs and combine them. Each file gets its own bookmark." |
*
* @param {Pc_Tut_Combine_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_combine_1 = /** @type {((inputs?: Pc_Tut_Combine_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Combine_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_combine_1(inputs)
	return zh_pc_tut_combine_1(inputs)
});
export { pc_tut_combine_1 as "pc.tut.combine.1" }